module.exports = __webpack_public_path__ + "static/media/25114627_1545557768827192_917739795_n.3c1d53bd.jpg";